var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 91,
    viewBox: "0 0 69 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4452 13.1417L34.2471 12.2768L32.2976 12.7233L32.5639 13.8861L18.7939 79.294L20.751 79.706L33.6288 18.5361L47.2977 78.2233L49.2472 77.7768L34.6116 13.868L34.7509 13.206L34.4452 13.1417Z",
    fill: "#7ABB5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3421 45.1976L58.79 45.0706L58.5696 44.2928L58.7613 43.5302L58.3221 43.4198L58.2446 43.1464L57.7699 43.281L13.0166 32.0302L12.529 33.9699L53.9142 44.3739L11.0001 56.5379L11.5455 58.4621L57.8009 45.351L58.2736 45.4698L58.3421 45.1976Z",
    fill: "#7ABB5C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 67,
    height: 89,
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 31H67.5",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 61H67.5",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.9c6b1632dbe6847b35a1d0bc69babf36.svg";
export { ForwardRef as ReactComponent };